import { z } from 'zod/v3';
import { transformNullish } from '../../../../../common/utils';
import { AlgorithmJoinFormDataType, AlgorithmJoinQueryDtoType } from '../types';
import { AlgorithmJoinFormDataSchema } from './AlgorithmJoinFormDataSchema';

export const AlgorithmJoinsFormDataSchema = z.object({
  algorithmId: z.number(),
  joins: transformNullish<
    AlgorithmJoinFormDataType[],
    AlgorithmJoinQueryDtoType[]
  >(AlgorithmJoinFormDataSchema.array(), []),
});
